import styles from "./TestimonialCard.module.css";

function TestimonialCard({ text, name, title, org }) {
    return (
        <div className={[styles.item, styles.testimonial_card].join(" ")}>
            <div className={styles.content_container}>
                <img
                    src="/images/open-quote-orange.svg"
                    alt="open quote symbol"
                    className={styles.card_quote_icon}
                />
                <div
                    className={[
                        styles.text_overflow_container,
                        "hide-scrollbar",
                    ].join(" ")}
                >
                    <p className={styles.text}>{text}</p>
                    {/* <div
                        style={{
                            width: 100,
                            height: 500,
                            backgroundColor: "blue",
                        }}
                    ></div> */}
                </div>
                <div className={styles.card_bottom}>
                    <strong className={styles.card_name}>{name}</strong>
                    <div className={styles.card_title}>{title}</div>
                    <div className={styles.card_title}>{org}</div>
                </div>
            </div>
        </div>
    );
}

export default TestimonialCard;
